/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-02 17:19:51
 * @LastEditors: caiqin.xie
 * @message: 标题组件
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { DOMAIN_API } from '@/common/const'
import styles from "../../index.module.scss";

const Facebook_icon = require('../../../assets/Facebook.svg');
const Twitter_icon = require('../../../assets/Twitter.svg');

interface IProps {
  ctry: string;
  words: Record<string, string>;
  title: string;
}

const TopTitle = (props:IProps) => {
  const {ctry, words, title} = props
  const location = useLocation()
  return (
    <div className={styles['blog-top']}>
      {/* 占位 */}
      <div className={styles['blog-placeholder']}></div>
      {/* 标题 */}
      <div className={styles['blog-title']}>
        <div className={styles['bread-nav']}>
          <a href={`/${ctry}/`}>{words?.blog_breadcrumb_home}</a> &gt; 
          <a href={`/${ctry}/blog`}>{words?.blog_breadcrumb_blog}</a> &gt; 
          {title}
          {/* Home>blog */}
        </div>
        <h1>{title}</h1>
        {/* 文章分享 */}
        <p className={styles['blog-article-author']}>
          <span className={styles['blog-article-icon']}>
            <a
              href={`https://facebook.com/sharer/sharer.php?u=${DOMAIN_API}${location.pathname}`}
              target="_blank"
              rel="noopener noreferrer">
                <img src={Facebook_icon} alt={words?.common_facebook} />
                {/* Facebook */}
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${DOMAIN_API}${location.pathname}&text=${title}`}
              target="_blank"
              rel="noopener noreferrer">
                <img src={Twitter_icon} alt={words?.common_twitter} />
                {/* Twitter */}
            </a>
          </span>
        </p>
      </div>
    </div>
  )
}
export default TopTitle